"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_spring_1 = require("react-spring");
var Popper_1 = __importDefault(require("@seaweb/coral/components/Popper"));
var getRoot_1 = __importStar(require("@seaweb/coral/utils/getRoot"));
var TipContent_1 = __importDefault(require("./TipContent"));
var TipReference_1 = __importDefault(require("./TipReference"));
var TipContext_1 = __importDefault(require("./TipContext"));
var Tip = react_1.forwardRef(function Tip(_a, ref) {
    var children = _a.children, active = _a.active, immediate = _a.immediate, springConfig = _a.springConfig, _b = _a.container, container = _b === void 0 ? (getRoot_1.warnSSR('Tip', 'container'), getRoot_1.default()) : _b, content = _a.content, props = __rest(_a, ["children", "active", "immediate", "springConfig", "container", "content"]);
    var transitions = react_spring_1.useTransition(active, null, {
        immediate: immediate,
        from: { life: 0 },
        enter: { life: 1 },
        leave: { life: 0 },
        config: springConfig,
    });
    var el = transitions.map(function (_a) {
        var key = _a.key, item = _a.item, springProps = _a.props, phase = _a.phase;
        return item && (react_1.default.createElement(TipContext_1.default.Provider, { key: key, value: { phase: phase } },
            react_1.default.createElement(TipContent_1.default, __assign({ ref: ref, springProps: springProps }, props), content)));
    });
    var child = react_1.Children.only(children);
    return (react_1.default.createElement(Popper_1.default, null,
        react_1.default.createElement(TipReference_1.default, null, child),
        container === null ? el : react_dom_1.createPortal(el, container)));
});
exports.default = react_1.memo(Tip);
